// extracted by mini-css-extract-plugin
export default {"image":"ComponentImage_image__+d-0y"};